.wrapper {
  align-items: flex-start;
  background: var(--color-tertiary-background);
  border: 2px solid var(--color-border);
  border-radius: 6px;
  color: var(--color-tertiary-fg);
  display: flex;
  gap: 0.625rem;
  padding: 0.75rem 1.25rem;
}

.wrapper :global(svg) {
  color: var(--color-border);
  flex-shrink: 0;
}

.content {
  min-width: 0;
}

.body {
  margin: 0;
}
